import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: "login",
    component: () => import("../pages/login/login.vue"),
    meta: {
      title: "登录",
      showInbreadcrumb: false
    }
  },
  {
    path: '/sso',
    name: "sso",
    component: () => import("../pages/sso/sso.vue"),
    meta: {
      title: "三方授权",
      showInbreadcrumb: false
    }
  },
  {
    path: '/home',
    name: "home",
    component: () => import("../pages/home/home.vue"),
    meta: {
      title: "首页",
      showInbreadcrumb: false // 是否显示在面包屑中
    }
  },
  {
    path: '/userInfo',
    name: "userInfo",
    component: () => import("../pages/userInfo/userInfo.vue"),
    meta: {
      title: "移动端个人信息",
      showInbreadcrumb: false
    }
  },
  {
    path: '/regin',
    name: "regin",
    component: () => import("../pages/regin/regin.vue"),
    meta: {
      title: "注册",
      showInbreadcrumb: false
    }
  },
  {
    path: '/aboutUs',
    name: "aboutUs",
    component: () => import("../pages/aboutUs/aboutUs.vue"),
    meta: {
      title: "关于我们",
      showInbreadcrumb: true
    }
  },
  {
    path: '/createMeetingQuick',
    name: "createMeetingQuick",
    meta: {
      title: "快速创建",
      showInbreadcrumb: true
    },
    component: () => import("../pages/createMeetingQuick/createMeetingQuick.vue")
  },
  {
    path: '/bookMeeting',
    name: "bookMeeting",
    meta: {
      title: "预约会议",
      showInbreadcrumb: true
    },
    component: () => import("../pages/bookMeeting/bookMeeting.vue")
  },
  {
    path: '/joinMeeting',
    name: "joinMeeting",
    meta: {
      title: "加入会议",
      showInbreadcrumb: true
    },
    component: () => import("../pages/joinMeeting/joinMeeting.vue")
  },
  {
    path: '/meetingDetails',
    name: "meetingDetails",
    meta: {
      title: "会议详情",
      showInbreadcrumb: true
    },
    component: () => import("../pages/meetingDetails/meetingDetails.vue")
  },
  {
    path: '/appointmentDetail',
    name: "appointmentDetail",
    meta: {
      title: "预约详情",
      showInbreadcrumb: true
    },
    component: () => import("../pages/appointmentDetail/appointmentDetail.vue")
  },
  {
    path: '/historyMeeting',
    name: "historyMeeting",
    meta: {
      title: "查看历史",
      showInbreadcrumb: true
    },
    component: () => import("../pages/historyMeeting/historyMeeting.vue")
  },
  {
    path: '/userCenter',
    name: "userCenter",
    meta: {
      title: "个人中心",
      showInbreadcrumb: false
    },
    component: () => import("../pages/userCenter/userCenter.vue")
  },
  {
    path: '/exclusiveMeetingCode',
    name: "exclusiveMeetingCode",
    meta: {
      title: "专属与真",
      showInbreadcrumb: true
    },
    component: () => import("../pages/exclusiveMeetingCode/exclusiveMeetingCode.vue")
  },
  {
    path: '/accountSettings',
    name: "accountSettings",
    meta: {
      title: "账号设置",
      showInbreadcrumb: true
    },
    component: () => import("../pages/accountSettings/accountSettings.vue")
  },
  {
    path: '/welfareCenter',
    name: "welfareCenter",
    meta: {
      title: "福利中心",
      showInbreadcrumb: true
    },
    component: () => import("../pages/welfareCenter/welfareCenter.vue")
  },
  {
    path: '/toRecord',
    name: "toRecord",
    meta: {
      title: "我的录制",
      showInbreadcrumb: true
    },
    component: () => import("../pages/toRecord/toRecord.vue")
  },
  {
    path: '/parameterSettings',
    name: "parameterSettings",
    meta: {
      title: "参数设置",
      showInbreadcrumb: true
    },
    component: () => import("../pages/parameterSettings/parameterSettings.vue")
  },
  {
    path: '/myRoom',
    name: "myRoom",
    meta: {
      title: "我的会议室",
      showInbreadcrumb: true
    },
    component: () => import("../pages/myRoom/myRoom.vue")
  },
  {
    path: '/addressBook',
    name: "addressBook",
    meta: {
      title: "我的通讯录",
      showInbreadcrumb: true
    },
    component: () => import("../pages/addressBook/addressBook.vue")
  },
  {
    path: '/orderList/:code?',
    name: "orderList",
    meta: {
      title: "我的账单",
      showInbreadcrumb: true
    },
    component: () => import("../pages/orderList/orderList.vue")
  },
  {
    path: '/orderList/:id(\\d+)',
    name: "orderList2",
    meta: {
      title: "我的账单",
      showInbreadcrumb: true
    },
    component: () => import("../pages/orderList/orderList.vue")
  },
  {
    path: '/billRecord',
    name: "billRecord",
    meta: {
      title: "发票记录",
      showInbreadcrumb: true
    },
    component: () => import("../pages/billRecord/billRecord.vue")
  },
  {
    path: '/noticeList',
    name: "noticeList",
    meta: {
      title: "消息提醒",
      showInbreadcrumb: true
    },
    component: () => import("../pages/noticeList/noticeList.vue")
  },
  {
    path: '/consumptionDetail',
    name: "consumptionDetail",
    meta: {
      title: "消费信息",
      showInbreadcrumb: true
    },
    component: () => import("../pages/consumptionDetail/consumptionDetail.vue")
  },
  {
    path: '/myExclusiveInfo',
    name: "myExclusiveInfo",
    meta: {
      title: "专属与真信息",
      showInbreadcrumb: true
    },
    component: () => import("../pages/myExclusiveInfo/myExclusiveInfo.vue")
  },
  {
    path: '/customInfo',
    name: "customInfo",
    meta: {
      title: "企业信息",
      showInbreadcrumb: true
    },
    component: () => import("../pages/customInfo/customInfo.vue")
  },
  {
    path: '/yellowPages',
    name: "yellowPages",
    meta: {
      title: "企业黄页",
      showInbreadcrumb: true
    },
    component: () => import("../pages/customerService/yellowPages.vue")
  },
  {
    path: '/search',
    name: "yellowPagesSearch",
    meta: {
      title: "企业搜索",
      showInbreadcrumb: true
    },
    component: () => import("../pages/customerService/yellowPagesSearch.vue")
  },
  {
    path: '/customerService',
    name: "customerService",
    meta: {
      title: "与真客服",
      showInbreadcrumb: true
    },
    component: () => import("../pages/customerService/customerService.vue")
  },
  {
    path: '/service/:domain',
    name: "service",
    meta: {
      title: "与真客服预约",
      showInbreadcrumb: false
    },
    component: () => import("../pages/customerService/customerServiceAppointment.vue")
  },
  {
    path: '/approve/:code',
    name: "approve",
    meta: {
      title: "与真黄页审核",
      showInbreadcrumb: false
    },
    component: () => import("../pages/customerService/customerServiceApprove.vue")
  },
  {
    path: '/customerServiceAppointmentPreview',
    name: "customerServiceAppointmentPreview",
    meta: {
      title: "与真黄页预览",
      showInbreadcrumb: false
    },
    component: () => import("../pages/customerService/customerServiceAppointmentPreview.vue")
  },
  {
    path: '/appointment/:domain?',
    name: "appointment",
    meta: {
      title: "与真客服预约",
      showInbreadcrumb: false
    },
    component: () => import("../pages/appointment/appointment.vue")
  },
  {
    path: '/appointmentPreview',
    name: "appointmentPreview",
    meta: {
      title: "与真客服预约预览",
      showInbreadcrumb: false
    },
    component: () => import("../pages/appointment/appointmentPreview.vue")
  },
  {
    path: '/device',
    name: "device",
    meta: {
      title: "设备绑定",
      showInbreadcrumb: true
    },
    component: () => import("../pages/device/device.vue")
  },
  {
    path: '/videoPlaying',
    name: "videoPlaying",
    meta: {
      title: "视频播放",
      showInbreadcrumb: true
    },
    component: () => import("../pages/videoPlaying/videoPlaying.vue")
  },
  {
    path: '/modifyMeeting',
    name: "modifyMeeting",
    meta: {
      title: "修改会议",
      showInbreadcrumb: true
    },
    component: () => import("../pages/modifyMeeting/modifyMeeting.vue")
  },
  {
    path: '/privacyAndSecurity',
    name: "privacyAndSecurity",
    meta: {
      title: "隐私与安全",
      showInbreadcrumb: true
    },
    component: () => import("../pages/privacyAndSecurity/privacyAndSecurity.vue")
  },
  {
    path: '/forgetPassword',
    name: "forgetPassword",
    component: () => import("../pages/forgetPassword/forgetPassword.vue"),
    meta: {
      title: "忘记密码",
      showInbreadcrumb: false
    }
  },
  {
    path: '/currentTime/:t',
    name: "currentTime",
    component: () => import("../pages/currentTime/currentTime.vue"),
    meta: {
      title: "当前时间",
      showInbreadcrumb: false
    }
  },
  {
    path: '/conversionTime/:mid/:timeZoneId',
    name: "conversionTime",
    component: () => import("../pages/conversionTime/conversionTime.vue"),
    meta: {
      title: "时区时间",
      showInbreadcrumb: false
    }
  },
  {
    path: '/support',
    name: "support",
    meta: {
      title: "支持与帮助",
      showInbreadcrumb: true
    },
    component: () => import("../pages/support/support.vue")
  },
  { path: '/:pathMatch(.*)', redirect: '/' } // 匹配所有未定义的路径并重定向到/
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router;
